export enum EWidgetCardCustomBreakpoint {
    ExtraSmall,
    Small,
    Medium,
    Large,
}
